export const COUNTIES = [
    { name: "St. Louis City", state: "MO" },
    { name: "St. Louis County", state: "MO" },
    { name: "St. Charles County", state: "MO" },
    { name: "Lincoln County", state: "MO" },
    { name: "Warren County", state: "MO" },
    { name: "Jefferson County", state: "MO" },
    { name: "Franklin County", state: "MO" },
    { name: "Washington County", state: "MO" },
    { name: "Madison County", state: "IL" },
    { name: "St. Clair County", state: "IL" },
    { name: "Monroe County", state: "IL" },
    { name: "Clinton County", state: "IL" },
    { name: "Perry County", state: "IL" },
    { name: "Jackson County", state: "IL" },
    { name: "Montgomery County", state: "MO" },
];

export const PACKAGE_TYPES = [
    { value: "lab_specimen", label: "Lab Specimens" },
    { value: "pharmaceutical", label: "Pharmaceuticals" },
    { value: "medical_supplies", label: "Medical Supplies" },
    { value: "documents", label: "Medical Documents" },
    { value: "other", label: "Other" },
];

export const URGENCY_LEVELS = [
    { value: "standard", label: "Standard (same day)" },
    { value: "stat", label: "STAT (urgent / rush)" },
    { value: "scheduled", label: "Scheduled (recurring / future)" },
];

export const STATUS_OPTIONS = [
    { value: "pending", label: "Pending", color: "bg-amber-100 text-amber-900 border-amber-300" },
    { value: "confirmed", label: "Confirmed", color: "bg-blue-100 text-blue-900 border-blue-300" },
    { value: "in_transit", label: "In Transit", color: "bg-indigo-100 text-indigo-900 border-indigo-300" },
    { value: "delivered", label: "Delivered", color: "bg-emerald-100 text-emerald-900 border-emerald-300" },
    { value: "cancelled", label: "Cancelled", color: "bg-rose-100 text-rose-900 border-rose-300" },
];

export const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_secure-delivery-hub-2/artifacts/05glc2a2_shefleet_logo_transparent.png";
